import React from 'react';
import { Flex, Text, xcss } from '@atlaskit/primitives';
import InformationIcon from '@atlaskit/icon/core/information';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export type CustomTemplateInlineMessageTypes = {
	isLiveTemplate?: boolean;
};

export const CustomTemplateInlineMessage = ({
	isLiveTemplate,
}: CustomTemplateInlineMessageTypes) => {
	const { formatMessage } = useIntl();

	return (
		isLiveTemplate && (
			<Flex alignItems="center" xcss={customTemplateInlineMessageStyles}>
				<InformationIcon label="" color="var(--ds-icon-discovery)" />
				<Text size="medium" weight="medium">
					{formatMessage(messages.savedAsTemplateInlineMessage)}
				</Text>
			</Flex>
		)
	);
};

const customTemplateInlineMessageStyles = xcss({
	paddingInlineStart: 'space.100',
	gap: 'space.075',
});
